import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import * as d3 from 'd3';

import touristsData from '../../data/open_data_3_beta.csv';
import { selectMonth,
         cancelSelectedMonth } from '../actions/index';

const pieChartWidth = 86;
const pieChartHeight = 86;
const pieRadius = 43;

const colorSets = [
  '#ffa08f',
  '#6bd2a1',
  '#ff676d',
  '#1d916f',
  '#ffd7d0',
  '#998675',
  '#62b5ff',
  '#736357',
  '#1877ff',
  '#62608e',
];

const countries = {
  HongKong: '港澳',
  China: '大陸',
  Japan: '日本',
  Korea: '韓國',
  Malaysia: '馬來西亞',
  Singapore: '新加坡',
  UnitedState: '美國',
  Europe: '歐洲',
  Australia: '澳洲',
  Others: '其他',
};

class PieChart extends Component {
  constructor(props) {
    super(props);
    this.isSelected = this.isSelected.bind(this);
    this.renderPieChart = this.renderPieChart.bind(this);
  }

  componentDidMount() {
    const colors = d3.scaleOrdinal()
                     .range(colorSets);

    const arc = d3.arc()
                 .outerRadius(pieRadius)
                 .innerRadius(pieRadius * 0.41);

    const pie = d3.pie().sort(null)
                 .value(d => d.tourists);

    touristsData.forEach(data => {
      const svg = d3.select(`#pie-chart-${data.year}-${data.month}`)
                    .append('svg')
                    .attr('preserveAspectRatio', 'xMinYMin meet')
                    .attr('viewBox', `0 0 ${pieChartWidth} ${pieChartHeight}`)
                    .append('g')
                    .attr('transform', `translate(${pieChartWidth / 2},${pieChartHeight / 2})`)
                    .attr('class', 'pie');

      const dataArray = [];
      const total = data.total;
      Object.keys(data).forEach(key => {
        if (!['year', 'month', 'total', 'avgExchangeRate'].find(name => name === key)) {
          dataArray.push({ area: key, tourists: data[key] });
        }
      });

      const g = svg.selectAll('.pie')
         .data(pie(dataArray))
         .enter().append('g')
         .attr('class', 'arc');

      g.append('path')
        .attr('d', arc)
        .attr('fill', (datum, index) => colors(index))
        .attr('class', 'pie-part');

      // g.append('text')
      //   .attr('transform', d => {
      //     const c = arc.centroid(d);
      //     return `translate(${c[0] * 1.6},${c[1] * 1.6})`;
      //   })
      //   .attr('text-anchor', 'middle')
      //   .attr('class', 'text')
      //   .attr('dy', '.35em')
      //   .text((datum) => {
      //     const percent = datum.data.tourists / total * 100;
      //
      //     return `${parseFloat(percent).toFixed(2)}%`;
      //   });
    });

    // hide all pie chart
    [].forEach.call(document.querySelectorAll('.pie-chart'), pieBlock => {
      pieBlock.style.display = 'none';
    });
  }

  componentDidUpdate(prevProps) {
    prevProps.comparedMonths.forEach(date => {
      document.getElementById(`pie-${date.year}-${date.month}`).style.display = 'none';
    });
    this.props.comparedMonths.forEach(date => {
      document.getElementById(`pie-${date.year}-${date.month}`).style.display = 'inline-block';
    });
  }

  isSelected(y, m) {
    return this.props.comparedMonths.find(d =>
      d.year === y && d.month === m);
  }

  renderPieChart() {
    return touristsData.map(data =>
      <div
        className="pie-chart"
        key={`pie-${data.year}-${data.month}`}
        id={`pie-${data.year}-${data.month}`}
      >
        <div className="info-group">
          <div className="info -date">
            {`${data.year}年 ${data.month}月`}
          </div>
          <div className="info -people">
            {`來臺人數:${data.total} | 美金匯率:${parseFloat(data.avgExchangeRate).toFixed(2)}`}
          </div>
        </div>
        <div className="pie-wrapper">
          <div
            id={`pie-chart-${data.year}-${data.month}`}
            className="svg-container"
          ></div>
        </div>
        <div className="chart-note">
          <div className="area-wrapper">
          {Object.keys(data).map(key => (
            !['year', 'month', 'total', 'avgExchangeRate'].find(name => name === key) ?
              <div className="area-block" key={`${data.year}-${data.month}-${key}`}>
                <span className={'area -' + key.toLowerCase()}>
                  {countries[key]}
                </span>
                <span className="number">
                  {`${parseFloat(data[key] / data.total * 100).toFixed(0)}%`}
                </span>
              </div> : null))}
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        <div className="pie-charts">
          <div className="container">
            {this.renderPieChart()}
          </div>
        </div>
        {/* <button
          type="button"
          onClick={() => this.props.cancelSelectedMonth()}
        >
          Cancel Selection
        </button>*/}
      </div>
    );
  }
}

PieChart.propTypes = {
  selectMonth: PropTypes.func,
  cancelSelectedMonth: PropTypes.func,
  selectSimilarExRateMonths: PropTypes.func,
  displayedYear: PropTypes.object,
  selectedMonth: PropTypes.object,
  comparedMonths: PropTypes.array,
};

const mapStateToProps = (state) => ({
  displayedYear: state.date.displayedYear,
  selectedMonth: state.date.selectedMonth,
  comparedMonths: state.date.comparedMonths,
});

export default connect(mapStateToProps,
  { selectMonth, cancelSelectedMonth })(PieChart);



/** WEBPACK FOOTER **
 ** ./src/components/pie_chart.js
 **/